import './YouTubeEmbedWrapper.scss';

import { Spinner } from '@travelwin/core';
import { useEffect, useRef, useState } from 'react';

import { useConsent } from '@/context/Consent';

import { OptInToMarketingConsent } from './OptInToMarketingConsent';

const className = 'c-YouTubeEmbedWrapper';

const maxWidth = 720;

export const YouTubeIframe = ({
  url,
  autoplay = false,
}: {
  url: string;
  autoplay?: boolean;
}) => {
  const videoUrl = new URL(url);
  if (autoplay) {
    videoUrl.searchParams.set('autoplay', '1');
  }

  const youtubeRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [youtubeWidth, setYoutubeWidth] = useState(0);
  const [youtubeHeight, setYoutubeHeight] = useState(0);

  const { enabled, consent } = useConsent();

  // Adjust the YouTube embed size based on the container width
  useEffect(() => {
    const handleResize = () => {
      if (youtubeRef.current) {
        if (url.includes('shorts')) {
          const width = Math.min(youtubeRef.current.offsetWidth, maxWidth / 2);
          setYoutubeWidth(width);
          setYoutubeHeight((width / 9) * 16);
        } else {
          const width = Math.min(youtubeRef.current.offsetWidth, maxWidth);
          setYoutubeWidth(width);
          setYoutubeHeight((width / 16) * 9);
        }
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [url, isLoading]);

  if (enabled && consent && !consent.marketing) {
    return <OptInToMarketingConsent />;
  }

  return (
    <div ref={youtubeRef} className={`${className}__youtube-container`}>
      {!enabled || isLoading ? <Spinner /> : null}
      <iframe
        width={youtubeWidth}
        height={youtubeHeight}
        src={url}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        onLoad={() => {
          setIsLoading(false);
        }}
        style={{ display: isLoading ? 'none' : 'block' }}
      ></iframe>
    </div>
  );
};
